import { Link } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "./Univ";
import { useEffect, useState } from "react";

import { useAuth } from "./context/AuthContext";
import "./MyStyles.css";

function Header() {

  const { logoutUser } = useAuth();

  const [cartCount, setCartCount] = useState(0);

  const isLoggedIn = localStorage.getItem("user_login") === "true";
  const userRole = localStorage.getItem("userGroup");
  const userName = localStorage.getItem("username");

  const handleLogout = () => {
    logoutUser();
    window.location.href = "/";
  };

  // -----------------------------
  // FETCH CART COUNT (CUSTOMER)
  // -----------------------------
  useEffect(() => {

    if (isLoggedIn && userRole === "Customer") {

      axios
        .get(baseUrl + "cart/", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        })
        .then((res) => {

          const totalQty = res.data.items.reduce(
            (sum, item) => sum + item.quantity,
            0
          );

          setCartCount(totalQty);

        })
        .catch((err) => console.log(err));

    }

  }, [isLoggedIn, userRole]);

  // -----------------------------
  // UI
  // -----------------------------
  return (

    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">

      <div className="container-fluid">

        {/* LOGO */}
        <Link className="navbar-brand me-3" to="/">
          <i className="fa-solid fa-cart-shopping me-2"></i>
          e-Comm
        </Link>

        {/* TOGGLER */}
        <button
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#menu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div id="menu" className="collapse navbar-collapse">

          {/* -------------------------------- */}
          {/* LEFT MENU */}
          {/* -------------------------------- */}
          <ul className="navbar-nav me-auto align-items-center">

            {/* PUBLIC */}
            <li className="nav-item">
              <Link to="/products" className="nav-link">
                <i className="fa-solid fa-store me-1"></i>
                Products
              </Link>
            </li>

            {/* ADMIN */}
            {isLoggedIn && userRole === "Admin" && (
              <>
                <li className="nav-item">
                  <Link to="/admin" className="nav-link">Dashboard</Link>
                </li>

              </>
            )}

            {/* SELLER */}
            {isLoggedIn && userRole === "Seller" && (
              <>
                <li className="nav-item">
                  <Link to="/seller" className="nav-link">Dashboard</Link>
                </li>

                <li className="nav-item">
                  <Link to="/seller/add-product" className="nav-link">
                    Add Product
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/seller/products" className="nav-link">
                    My Products
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/seller/orders" className="nav-link">
                    Orders
                  </Link>
                </li>

              </>
            )}
            {/* Driver */}
            {isLoggedIn && userRole === "Driver" && (
              <>
                <li className="nav-item">
                  <Link to="/driver/dashboard" className="nav-link">Dashboard</Link>
                </li>

              </>
            )}

            {/* CUSTOMER */}
            {isLoggedIn && userRole === "Customer" && (
              <>
                <li className="nav-item">
                  <Link to="/cart" className="nav-link position-relative">

                    <i className="fa-solid fa-cart-shopping me-1"></i>

                    {cartCount > 0 && (
                      <span className="cart-badge">{cartCount}</span>
                    )}

                    Cart
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/wishlist" className="nav-link">
                    Wishlist
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/orders" className="nav-link">
                    Orders
                  </Link>
                </li>

              </>
            )}

          </ul>

          {/* -------------------------------- */}
          {/* RIGHT MENU */}
          {/* -------------------------------- */}
          <ul className="navbar-nav ms-auto align-items-center">

            {/* IF NOT LOGGED IN */}
            {!isLoggedIn && (
              <>
                <li className="nav-item">
                  <Link to="/user-login/" className="nav-link">
                    <i className="fa-solid fa-right-to-bracket me-1"></i>
                    Sign In
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/user-register/" className="nav-link">
                    <i className="fa-solid fa-user-plus me-1"></i>
                    Register
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/seller-register/" className="nav-link">
                    <i className="fa-solid fa-user-plus me-1"></i>
                    Seller
                  </Link>
                </li>
              </>
            )}

            {/* IF LOGGED IN */}
            {isLoggedIn && (
              <li className="nav-item dropdown">

                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  <i className="fa-solid fa-user me-1"></i>
                  {userName}
                </a>

                <ul className="dropdown-menu dropdown-menu-end">

                  <li className="dropdown-item-text">
                    Role: {userRole}
                  </li>

                  <li><hr className="dropdown-divider" /></li>

                  {userRole === "Seller" && (
                    <li>
                      <Link className="dropdown-item" to="/seller/details/">
                        Seller Profile
                      </Link>
                    </li>
                  )}

                  {userRole === "Customer" && (
                    <li>
                      <Link className="dropdown-item" to="/edit-profile/">
                        My Profile
                      </Link>
                    </li>
                  )}

                  <li>
                    <Link className="dropdown-item" to="/change-password/">
                      Change Password
                    </Link>
                  </li>

                  <li><hr className="dropdown-divider" /></li>

                  <li>
                    <button
                      onClick={handleLogout}
                      className="dropdown-item text-danger"
                    >
                      Logout
                    </button>
                  </li>

                </ul>

              </li>
            )}

          </ul>

        </div>

      </div>

    </nav>
  );
}

export default Header;
